"use client";

import { transformText } from "@/utils/transformText";
import Text from "../Text";
import GradientLightText from "../GradientLightText";
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

type PathTitleProps = {
  baseText: string;
  words: string[];
};

const PathTitle = ({ baseText, words }: PathTitleProps) => {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState(words[0]);
  useEffect(() => {
    const timerId = setInterval(() => {
      setIndex((currentIndex) => (currentIndex + 1) % words.length);
    }, 3000);

    return () => clearInterval(timerId);
  }, [words.length]);

  useEffect(() => {
    setText(`${words[index]}`);
  }, [words, index]);

  const animationVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  };

  return (
    <>
      <AnimatePresence>
        <Text element="h1" elementStyle="h1">
          {transformText(baseText, {
            gradient: (chunk) => (
              <GradientLightText element="span">{chunk}</GradientLightText>
            ),
          })}{" "}
          <motion.span
            key={text}
            variants={animationVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            className="light-gradient"
          >
            {text}
          </motion.span>
        </Text>
      </AnimatePresence>
    </>
  );
};

export default PathTitle;
